import { render } from "./BpmValue.vue?vue&type=template&id=39a159be&scoped=true"
import script from "./BpmValue.vue?vue&type=script&lang=js"
export * from "./BpmValue.vue?vue&type=script&lang=js"

import "./BpmValue.vue?vue&type=style&index=0&id=39a159be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a159be"]])

export default __exports__